export default class SystemApi {
    getDateFormat(dateText) {
        const date = new Date(dateText)
        return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
    }

    getDateTimeFormat(dateText) {
        const date = new Date(dateText)
        const minutes = date.getMinutes()

        return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.getHours()}:${String(minutes).length === 1 ? `0${minutes}` : minutes}`
    }
}



// WEBPACK FOOTER //
// ./src/api/system-api/SystemApi.js